import React from 'react';
import { Header, Icon, Step } from 'semantic-ui-react';

import STEPS from './steps';

class CustomerMigration extends React.Component {
  state = {step: 0};

  render() {
    const { step } = this.state;
    const { handleFirstStep, handleNextStep } = this;
    return (
      <React.Fragment>
        <Header as="h2">Customer Migration Utility for DialSource Denali 2.0</Header>
        <Step.Group>
          {STEPS.map((s, index) => (
            <Step key={index} active={index === step} disabled={index > step}>
              <Icon name={s.icon} />
              <Step.Content>
                <Step.Title>{s.title}</Step.Title>
                <Step.Description>{s.description}</Step.Description>
              </Step.Content>
            </Step>
          ))}
        </Step.Group>
        <div>
          {React.createElement(STEPS[step].component, {firstStep: handleFirstStep, nextStep: handleNextStep})}
        </div>
      </React.Fragment>
    );
  }

  handleFirstStep = (e) => {
    e.preventDefault();
    this.setState((state) => ({...state, step: 0}));
  };

  handleNextStep = () => {
    this.setState((state) => ({...state, step: state.step + 1}));
  };
}

export default CustomerMigration;
